var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#2D4EE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.1445H22.3437V16.8762H4.50681C4.77619 13.4971 6.31669 10.3442 8.81969 8.04916C11.3227 5.75413 14.6033 4.48647 18.0044 4.50011C25.3647 4.48655 31.3336 10.3287 31.4969 17.7357C31.5716 21.2377 30.2753 24.6312 27.8828 27.1971C25.4903 29.7629 22.1895 31.2997 18.6797 31.4818C15.1699 31.6638 11.7269 30.4769 9.08003 28.1724C6.4332 25.8679 4.79051 22.6269 4.5 19.1361V19.1445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.72086d0df6b7ea32635c6a5e86e44994.svg";
export { ForwardRef as ReactComponent };